import React, { memo } from "react";
import { useProjectUIStore } from "stores/projectStore";
import { Icon } from "components/Icon/Icon";
import { useProductImage } from "hooks";

export const ProductImage = memo(
  ({ pimId, productImagesDisabled, productName, width, height }) => {
    const showProductPictures = useProjectUIStore(
      (state) => state.showProductPictures,
    );
    const { productImage, fetching } = useProductImage(pimId);

    return (
      <>
        {showProductPictures && !productImagesDisabled && (
          <div className="icon-64 d-flex align-items-center justify-content-center">
            {productImage ? (
              <img
                src={productImage}
                width={width}
                height={height}
                className="w-100 h-100 object-fit-contain m-0"
                alt={productName}
              />
            ) : (
              <>
                {!pimId || fetching ? (
                  <Icon
                    className="icon-64 m-2"
                    prefix="trox"
                    iconName="squares-light"
                  />
                ) : null}
              </>
            )}
          </div>
        )}
      </>
    );
  },
);
